import React, { useState } from 'react';
import TermsModal from './TermsModal';
import PrivacyModal from './PrivacyModal';
import './Footer.css';

const Footer = () => {
  const [showTerms, setShowTerms] = useState(false);
  const [showPrivacy, setShowPrivacy] = useState(false);

  return (
    <>
      <footer className="app-footer">
        <div className="footer-content">
          <p className="footer-memorial">In memory of Jeffrey Lucas Gurmendi Marshall</p>
          
          <div className="footer-legal">
            <button 
              className="footer-link-button"
              onClick={() => setShowTerms(true)}
            >
              Terms
            </button>
            <span className="footer-separator">•</span>
            <button 
              className="footer-link-button"
              onClick={() => setShowPrivacy(true)}
            >
              Privacy Policy
            </button>
          </div>
          
          <p className="footer-copyright">
            © 2025 DoZESQ Imaginarium. All rights reserved.
          </p>
        </div>
      </footer>

      <TermsModal isOpen={showTerms} onClose={() => setShowTerms(false)} />
      <PrivacyModal isOpen={showPrivacy} onClose={() => setShowPrivacy(false)} />
    </>
  );
};

export default Footer;